import { useEffect } from "react";

/**
 * Lightweight SEO head manager (no external deps).
 * Sets document title + description + canonical + OG per route.
 */
export default function Seo({ title, description, path = "/", image }) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} — StUpEco Hub`
      : "StUpEco Hub — One place where businesses grow together";
    document.title = fullTitle;

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [key, val] = selector
          .replace("meta[", "")
          .replace("]", "")
          .split("=");
        el.setAttribute(key, val.replace(/["']/g, ""));
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
    }
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    if (image) {
      setMeta('meta[property="og:image"]', "content", image);
      setMeta('meta[name="twitter:image"]', "content", image);
      setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
    }

    const base = "https://business-growth-hub-100.preview.emergentagent.com";
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${base}${path}`);
    setMeta('meta[property="og:url"]', "content", `${base}${path}`);
  }, [title, description, path, image]);

  return null;
}
